export const getAppOrigin = () => {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  return `${window.location.protocol}//${window.location.host}`;
};

